import React from "react";
import { useAccessToken } from "@/Auth/useAccessToken";
import { useQueryClient } from "@tanstack/react-query";

export function useLogout() {
  const queryClient = useQueryClient();
  const { removeAccessToken } = useAccessToken();

  const logout = React.useCallback(() => {
    removeAccessToken();
    queryClient.cancelQueries().then(() => {
      queryClient.clear();
    });
  }, [queryClient, removeAccessToken]);

  return { logout };
}
